import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export function DownloadData() {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/auth/my-data");
      const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }));
      const a = Object.assign(document.createElement("a"), { href: url, download: `isoldit-my-data-${new Date().toISOString().slice(0, 10)}.json` });
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success("Your data has been downloaded");
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="download-data-section" className="mt-6 flex max-w-xl flex-col gap-4 rounded-2xl bg-[#173742] p-6 sm:flex-row sm:items-center">
      <div className="flex-1">
        <p className="font-semibold">Download my data</p>
        <p className="mt-1 text-sm text-slate-400">Get a copy of your profile, listings, messages, reviews, saved items and searches as a file.</p>
      </div>
      <button data-testid="download-data-btn" onClick={download} disabled={busy} className="inline-flex shrink-0 items-center gap-2 rounded-xl border border-white/15 px-4 py-2.5 text-sm font-semibold hover:bg-white/5"><Download className="h-4 w-4" />{busy ? "Preparing…" : "Download"}</button>
    </div>
  );
}
